import { LoginPanelContainer } from "../../login/ui"

export default function Page(props) {
  return <LoginPanelContainer {...props} />
}